import { useState } from 'react'
import { Box, Grid2 } from '@mui/material'
import CustomDivider from '../../shared/utils/CustomDivider'
import { useAdminApartmentList, useAdminStudentList, useAllSchoolList } from '../../assets/api/useAdminApi'
import { Field, } from 'formik'
import { AutoCompleteField } from '../../shared/components/formfields/AutoCompleteField'
import CustomSlider from '../../shared/components/formfields/CustomSlider'
import { IdAutoCompleteField } from '../../shared/components/formfields/IdAutoCompleteField'
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate'
import { useStudentColumnsWithDialog } from '../../shared/utils/useStudentColumnsWithDialog'
import { LocationFilterFields } from '../../shared/components/LocationFilterFields'

const StudentList = () => {
  const { studentColumns, dialogJSX, viewStudentCourse } = useStudentColumnsWithDialog();
  const [filters, setFilters] = useState({});
  const { data: studentlist, isLoading } = useAdminStudentList(filters)
  const { data: apartmentlist, isLoading: apartmentLoading } = useAdminApartmentList()
  const { data: schoolList, isLoading: isSchoolListLaoding } = useAllSchoolList()
  const schoolOption = schoolList
    ?.data?.filter((item) => item != null)
    .map((item, index) => ({
      id: index + 1,
      label: item,
      value: item,
    }));
  const apartmentOption = apartmentlist?.data?.map((item, index) => ({
    id: index + 1,
    label: item?.apartment_name,
    value: item?.apartment_name,
  }))
  const statusOption = [
    {
      id: 1,
      label: "Subscribe",
      value: "Subscribe"
    },
    {
      id: 0,
      label: "Unsubscribe",
      value: "Unsubscribe"
    },

  ]

  const getFilteredValuesWithAge = (values) => {
    const { age, ...rest } = values;

    const baseFiltered = Object.fromEntries(
      Object.entries(rest).filter(([_, v]) => v !== "" && v !== null && v !== undefined)
    );

    if (Array.isArray(age) && age.length === 2) {
      return {
        ...baseFiltered,
        min_age: age[0],
        max_age: age[1],
      };
    }

    return baseFiltered;
  };

  return (
    <Box>
     
      <CustomDivider />
     
      <TableFilterTemplate
        title="Student List"
        columns={studentColumns}
        rowsData={studentlist?.data || []}
        isLoading={isLoading}
        filterInitialValues={filters}
        filterReset={() => setFilters({})}
        onApplyFilters={(f) => setFilters(f)}
        filterTransformer={getFilteredValuesWithAge}
        renderFilterFields={() => (

          <>
            <Grid2 children size={12}>
              <Field
                name="apartment_name"
                component={AutoCompleteField}
                options={apartmentOption}
                isLoading={apartmentLoading}
                label="Apartment Name"
                isRequired={true}
              />
            </Grid2>
            <Grid2 children size={12}>
              <Field
                name="school_name"
                component={AutoCompleteField}
                options={schoolOption}
                label="School Name"
                isLoading={isSchoolListLaoding}
                isRequired={true}
              />
            </Grid2>
            <Grid2 children size={12}>
              <Field
                name="subscription_status"
                component={IdAutoCompleteField}
                options={statusOption}
                label="Status"
                isRequired={true}
              />
            </Grid2>
            <LocationFilterFields
              countryField="country_name"
              stateField="state"
              cityField="city"
              isStoredId={false}
            />
            <Grid2 children size={12}>
              <Field
                name="age"
                component={CustomSlider}
                label="Age"
                initialValue={0}
                finalValue={20}
              />
            </Grid2>
          </>

        )}

        dataGridProps={{
          onRowClick: (params) => viewStudentCourse(params.row)
        }}
        
      />

      {dialogJSX}

    </Box>
  )
}

export default StudentList